import { post, put } from './requests'

export function createSendingTemplate ({ documentTemplateId, ...sendingTemplate }) {
  return post(`document_templates/${documentTemplateId}/sending_template`, { sendingTemplate })
}

export function updateSendingTemplate ({ documentTemplateId, ...sendingTemplate }) {
  return put(`document_templates/${documentTemplateId}/sending_template`, { sendingTemplate })
}
